import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[licensingTierTemplateInsert]',
})
export class LicensingTierDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
